<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="403" height="259" viewBox="0 0 403 259">
  <defs>
    <filter id="Rectangle_41" x="0" y="0" width="403" height="259" filterUnits="userSpaceOnUse">
      <feOffset dy="3" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="3" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Search" transform="translate(-1281 -135)">
    <g transform="matrix(1, 0, 0, 1, 1281, 135)" filter="url(#Rectangle_41)">
      <rect id="Rectangle_41-2" data-name="Rectangle 41" width="385" height="241" rx="10" transform="translate(9 6)" fill="#f7f7f7"/>
    </g>
    <text id="Search-2" data-name="Search" transform="translate(1310 175)" fill="#5b4699" font-size="20" font-family="SegoeUI, Segoe UI" letter-spacing="0.05em"><tspan x="0" y="0">Search</tspan></text>
    <g id="button" transform="translate(36 -12)">
      <g id="Group_28" data-name="Group 28" transform="translate(803 -126)">
        <rect id="Rectangle_18" data-name="Rectangle 18" width="20" height="20" rx="5" transform="translate(799 297)" fill="#5b4699"/>
      </g>
      <g id="search-24px" transform="translate(1603 172)">
        <path id="Path_12" data-name="Path 12" d="M0,0H16.726V16.726H0Z" fill="none"/>
        <path id="Path_13" data-name="Path 13" d="M11.711,10.666h-.551l-.2-.188a4.537,4.537,0,1,0-.488.488l.188.2v.551l3.484,3.478,1.038-1.038Zm-4.181,0A3.136,3.136,0,1,1,10.666,7.53,3.132,3.132,0,0,1,7.53,10.666Z" transform="translate(0.091 0.091)" fill="#fafafa"/>
      </g>
    </g>
    <text id="result" transform="translate(1310 207)" fill="#707070" font-size="10" font-family="SegoeUI, Segoe UI" letter-spacing="0.05em"><tspan x="0" y="0">Search results for &quot;Hooli&quot;</tspan></text>
    <g id="list-journeys">
      <g id="Group_30" data-name="Group 30">
        <rect id="Rectangle_42" data-name="Rectangle 42" width="348" height="19" transform="translate(1310 223)" fill="#9ea8c9"/>
        <text id="Journeys" transform="translate(1317 236)" fill="#fafafa" font-size="10" font-family="SegoeUI, Segoe UI" letter-spacing="0.05em"><tspan x="0" y="0">Journeys</tspan></text>
      </g>
      <rect id="Rectangle_43" data-name="Rectangle 43" width="322" height="7" rx="3" transform="translate(1310 256)" fill="#9ea8c9"/>
    </g>
    <g id="list-apps">
      <rect id="Rectangle_46" data-name="Rectangle 46" width="322" height="7" rx="3" transform="translate(1310 331)" fill="#9ea8c9"/>
      <rect id="Rectangle_44" data-name="Rectangle 44" width="322" height="7" rx="3" transform="translate(1310 352)" fill="#9ea8c9"/>
      <rect id="Rectangle_45" data-name="Rectangle 45" width="322" height="7" rx="3" transform="translate(1310 310)" fill="#9ea8c9"/>
      <g id="Group_31" data-name="Group 31" transform="translate(0 54)">
        <rect id="Rectangle_42-2" data-name="Rectangle 42" width="348" height="19" transform="translate(1310 223)" fill="#9ea8c9"/>
        <text id="Applications" transform="translate(1317 236)" fill="#fafafa" font-size="10" font-family="SegoeUI, Segoe UI" letter-spacing="0.05em"><tspan x="0" y="0">Applications</tspan></text>
      </g>
    </g>
  </g>
</svg>
